import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import ProviderStatisticRepository from "~/repository/Provider/ProviderStatisticRepository";
import ProviderStatistic from "~/models/Provider/ProviderStatistic";

class ProviderStatisticStore extends NestStore {
  /**
   * @property {ProviderStatistic}
   */
  @observable providerStatistic = new ProviderStatistic();

  /**
   * @property {number|null}
   */
  providerId = null;

  providerStatisticRepository = null;

  constructor() {
    super();

    this.providerStatisticRepository = new ProviderStatisticRepository();
  }

  @action
  load(query = null) {
    this.isLoading = true;

    return Promise.all([this.getOne(query)]).finally(() => {
      this.isLoading = false;
    });
  }

  @action
  getOne(query = null) {
    return this.providerStatisticRepository.fetchOne(this.providerId, query).then(response => {
      this.providerStatistic = new ProviderStatistic(response.data.providerStatistic);
    });
  }
}

export default ProviderStatisticStore;
